import ChristmasStopsCardBg from '@/v2/components/assets/ChristmasStopsCardBg.vue';
import ChristmasUpdateIcon from '@/v2/components/assets/ChristmasUpdateIcon.vue';
import ValentinesStopsCardBg from '@/v2/components/assets/ValentinesStopsCardBg.vue';
import ValentinesUpdateIcon from '@/v2/components/assets/ValentinesUpdateIcon.vue';
import EasterStopsCardBg from '@/v2/components/assets/EasterStopsCardBg.vue';
import EasterUpdateIcon from '@/v2/components/assets/EasterUpdateIcon.vue';

export const SEASONAL_CONFIG = {
  christmas: {
    start: { month: 12, day: 1 },
    end: { month: 1, day: 7 },
    animation: {
      key: 'snow',
      durationMs: 5000 // 3000 + 2*1000ms for fade in/out
    },
    assets: {
      car: '/themes/v2/seasonal/red_ribbon_car.svg',
      destination: '/themes/v2/seasonal/christmas/christmas_destination.svg',
      destinationDelivered:
        '/themes/v2/seasonal/christmas/christmas_destination_delivered.svg',
      destinationNotDelivered:
        '/themes/v2/seasonal/christmas/christmas_destination_not_delivered.svg',
      parcel: '/themes/v2/seasonal/christmas/christmas_parcel.svg',
      parcelPlain: '/themes/v2/seasonal/christmas/christmas_parcel_plain.svg',
      parcelSuccess:
        '/themes/v2/seasonal/christmas/christmas_parcel_success.png',
      parcelshopRaster: '/themes/v2/seasonal/christmas/christmas_ps.png',
      parcelshopVector: '/themes/v2/seasonal/christmas/christmas_ps.svg',
      parcelshopDelivered:
        '/themes/v2/seasonal/christmas/christmas_ps_delivered.svg',
      stopsDescriptionCardBg: ChristmasStopsCardBg,
      updateIcon: ChristmasUpdateIcon
    },
    classes: {},
    styles: {
      stopsDescriptionCardBg: {
        top: -10
      },
      progressCircleBase: {
        stroke: '#E3F8E6'
      },
      progressCircleGradientDefs: {
        littleProgress: {
          stopColor0Pct: '#C2F4C7',
          stopColor15Pct: '#80D282',
          stopColor70Pct: '#53BC53',
          stopColor100Pct: '#3DB03C'
        },
        firstHalf: {
          stopColor0Pct: '#C2F4C7',
          stopColor15Pct: '#80D282',
          stopColor70Pct: '#53BC53',
          stopColor100Pct: '#3DB03C'
        },
        secondHalf: {
          stopColor0Pct: '#3DB03C',
          stopColor100Pct: '#27A525'
        }
      },
      progressCircleCar: {
        width: '33px',
        transform: 'translate(21px, -14px) rotate(90deg)'
      }
    }
  },
  valentines: {
    start: { month: 2, day: 10 },
    end: { month: 2, day: 14 },
    assets: {
      car: '/themes/v2/seasonal/red_ribbon_car.svg',
      stopsDescriptionCardBg: ValentinesStopsCardBg,
      updateIcon: ValentinesUpdateIcon
    },
    classes: { updateButtonAnimation: ['pulsing'] },
    styles: {
      stopsDescriptionCardBg: {
        top: -9
      },
      progressCircleBase: {
        stroke: '#FDF1F1'
      },
      progressCircleGradientDefs: {
        littleProgress: {
          stopColor0Pct: '#F5CCCE',
          stopColor15Pct: '#F49A9D',
          stopColor70Pct: '#F4787D',
          stopColor100Pct: '#F3686C'
        },
        firstHalf: {
          stopColor0Pct: '#F5CCCE',
          stopColor15Pct: '#F49A9D',
          stopColor70Pct: '#F4787D',
          stopColor100Pct: '#F3686C'
        },
        secondHalf: {
          stopColor0Pct: '#F3686C',
          stopColor100Pct: '#F3575C'
        }
      },
      progressCircleCar: {
        width: '33px',
        transform: 'translate(21px, -14px) rotate(90deg)'
      }
    }
  },
  easter: {
    assets: {
      stopsDescriptionCardBg: EasterStopsCardBg,
      updateIcon: EasterUpdateIcon
    },
    classes: { updateButtonAnimation: ['shaking'] },
    styles: {
      stopsDescriptionCardBg: {
        top: -10
      },
      progressCircleBase: {
        stroke: '#E3F8E6'
      },
      progressCircleGradientDefs: {
        littleProgress: {
          stopColor0Pct: '#C2F4C7',
          stopColor15Pct: '#80D282',
          stopColor70Pct: '#53BC53',
          stopColor100Pct: '#3DB03C'
        },
        firstHalf: {
          stopColor0Pct: '#C2F4C7',
          stopColor15Pct: '#80D282',
          stopColor70Pct: '#53BC53',
          stopColor100Pct: '#3DB03C'
        },
        secondHalf: {
          stopColor0Pct: '#3DB03C',
          stopColor100Pct: '#27A525'
        }
      }
    }
  }
};
